var map = {
	"./ActivitySetup": [
		8117,
		8117
	],
	"./ActivitySetup.vue": [
		8117,
		8117
	],
	"./AppFooter": [
		6893
	],
	"./AppFooter.vue": [
		6893
	],
	"./AppHeader": [
		1212
	],
	"./AppHeader.vue": [
		1212
	],
	"./MainActivity": [
		3899
	],
	"./MainActivity.vue": [
		3899
	],
	"./SetupUserType": [
		8151,
		8151
	],
	"./SetupUserType.vue": [
		8151,
		8151
	],
	"./begeleider/ActivityOverview": [
		3423,
		432,
		3423
	],
	"./begeleider/ActivityOverview.vue": [
		3423,
		432,
		3423
	],
	"./begeleider/ConnectionOverview": [
		73,
		73
	],
	"./begeleider/ConnectionOverview.vue": [
		73,
		73
	],
	"./begeleider/ExternalsiteBegeleider": [
		6189,
		6189
	],
	"./begeleider/ExternalsiteBegeleider.vue": [
		6189,
		6189
	],
	"./begeleider/setup/SetupBill": [
		1374,
		1374
	],
	"./begeleider/setup/SetupBill.vue": [
		1374,
		1374
	],
	"./begeleider/setup/SetupPassword": [
		442,
		442
	],
	"./begeleider/setup/SetupPassword.vue": [
		442,
		442
	],
	"./begeleider/setup/SetupProgram": [
		2011,
		432,
		2011
	],
	"./begeleider/setup/SetupProgram.vue": [
		2011,
		432,
		2011
	],
	"./begeleider/setup/SetupRoomName": [
		977,
		977
	],
	"./begeleider/setup/SetupRoomName.vue": [
		977,
		977
	],
	"./student/ActivityOverview": [
		6539,
		6539
	],
	"./student/ActivityOverview.vue": [
		6539,
		6539
	],
	"./student/activities/ActivityArgument": [
		1129,
		2385
	],
	"./student/activities/ActivityArgument.vue": [
		1129,
		2385
	],
	"./student/activities/ActivityFinish": [
		4334,
		4334
	],
	"./student/activities/ActivityFinish.vue": [
		4334,
		4334
	],
	"./student/activities/ActivityGevolgen": [
		4612,
		7147
	],
	"./student/activities/ActivityGevolgen.vue": [
		4612,
		7147
	],
	"./student/activities/ActivityInstructions": [
		8078,
		8078
	],
	"./student/activities/ActivityInstructions.vue": [
		8078,
		8078
	],
	"./student/activities/ActivityKoning": [
		6985,
		9528
	],
	"./student/activities/ActivityKoning.vue": [
		6985,
		9528
	],
	"./student/activities/ActivityMinister": [
		3272,
		4766
	],
	"./student/activities/ActivityMinister.vue": [
		3272,
		4766
	],
	"./student/activities/ActivitySpandoek": [
		7534,
		5242
	],
	"./student/activities/ActivitySpandoek.vue": [
		7534,
		5242
	],
	"./student/activities/ActivityTweedeKamer": [
		7334,
		2861
	],
	"./student/activities/ActivityTweedeKamer.vue": [
		7334,
		2861
	],
	"./student/activities/ComponentText": [
		9764,
		9764
	],
	"./student/activities/ComponentText.vue": [
		9764,
		9764
	],
	"./student/activities/ExternalSite": [
		7033,
		7033
	],
	"./student/activities/ExternalSite.vue": [
		7033,
		7033
	],
	"./student/activities/GameEnd": [
		8896,
		8066
	],
	"./student/activities/GameEnd.vue": [
		8896,
		8066
	],
	"./student/activities/MotionComic": [
		2982,
		2982
	],
	"./student/activities/MotionComic.vue": [
		2982,
		2982
	],
	"./student/activities/PhotoCheck": [
		4546,
		4546
	],
	"./student/activities/PhotoCheck.vue": [
		4546,
		4546
	],
	"./student/activities/WieWatWet": [
		1089,
		3470
	],
	"./student/activities/WieWatWet.vue": [
		1089,
		3470
	],
	"./student/activities/argument/ArgumentSelection": [
		9096,
		9096
	],
	"./student/activities/argument/ArgumentSelection.vue": [
		9096,
		9096
	],
	"./student/activities/argument/TakePhoto": [
		8719,
		7270,
		8719
	],
	"./student/activities/argument/TakePhoto.vue": [
		8719,
		7270,
		8719
	],
	"./student/activities/gevolgen/GevolgenStemmen": [
		6772,
		6772
	],
	"./student/activities/gevolgen/GevolgenStemmen.vue": [
		6772,
		6772
	],
	"./student/activities/gevolgen/GevolgenStemmenUitleg": [
		5478,
		5478
	],
	"./student/activities/gevolgen/GevolgenStemmenUitleg.vue": [
		5478,
		5478
	],
	"./student/activities/gevolgen/TakePhoto": [
		3791,
		7270,
		3791
	],
	"./student/activities/gevolgen/TakePhoto.vue": [
		3791,
		7270,
		3791
	],
	"./student/activities/gevolgen/VoorwaardenWetsvoorstel": [
		661,
		661
	],
	"./student/activities/gevolgen/VoorwaardenWetsvoorstel.vue": [
		661,
		661
	],
	"./student/activities/koning/HandtekeningPart": [
		1057,
		1057
	],
	"./student/activities/koning/HandtekeningPart.vue": [
		1057,
		1057
	],
	"./student/activities/koning/HandtekeningTooLate": [
		5017,
		5017
	],
	"./student/activities/koning/HandtekeningTooLate.vue": [
		5017,
		5017
	],
	"./student/activities/koning/HandtekeningWait": [
		3319,
		3319
	],
	"./student/activities/koning/HandtekeningWait.vue": [
		3319,
		3319
	],
	"./student/activities/koning/PuzzleViewer": [
		7747,
		5135,
		7747
	],
	"./student/activities/koning/PuzzleViewer.vue": [
		7747,
		5135,
		7747
	],
	"./student/activities/koning/TakePhoto": [
		9593,
		7270,
		9593
	],
	"./student/activities/koning/TakePhoto.vue": [
		9593,
		7270,
		9593
	],
	"./student/activities/koning/puzzle/Piece": [
		2544,
		5135
	],
	"./student/activities/koning/puzzle/Piece.js": [
		2544,
		5135
	],
	"./student/activities/koning/puzzle/Point": [
		8240,
		8240
	],
	"./student/activities/koning/puzzle/Point.js": [
		8240,
		8240
	],
	"./student/activities/koning/puzzle/PolyPiece": [
		9762,
		9762
	],
	"./student/activities/koning/puzzle/PolyPiece.js": [
		9762,
		9762
	],
	"./student/activities/koning/puzzle/Puzzle": [
		4688,
		5135
	],
	"./student/activities/koning/puzzle/Puzzle.js": [
		4688,
		5135
	],
	"./student/activities/koning/puzzle/Segment": [
		5947,
		5947
	],
	"./student/activities/koning/puzzle/Segment.js": [
		5947,
		5947
	],
	"./student/activities/koning/puzzle/Side": [
		855,
		855
	],
	"./student/activities/koning/puzzle/Side.js": [
		855,
		855
	],
	"./student/activities/koning/puzzle/Utils": [
		3011,
		3011
	],
	"./student/activities/koning/puzzle/Utils.js": [
		3011,
		3011
	],
	"./student/activities/minister/MinisterFotoUitleg": [
		6779,
		9160
	],
	"./student/activities/minister/MinisterFotoUitleg.vue": [
		6779,
		9160
	],
	"./student/activities/minister/MinisterSelection": [
		1716,
		1716
	],
	"./student/activities/minister/MinisterSelection.vue": [
		1716,
		1716
	],
	"./student/activities/minister/PasFotoControle": [
		2557,
		2557
	],
	"./student/activities/minister/PasFotoControle.vue": [
		2557,
		2557
	],
	"./student/activities/minister/PasFotoOverzicht": [
		5368,
		5368
	],
	"./student/activities/minister/PasFotoOverzicht.vue": [
		5368,
		5368
	],
	"./student/activities/minister/PasFotoSelectie": [
		2569,
		7270,
		2569
	],
	"./student/activities/minister/PasFotoSelectie.vue": [
		2569,
		7270,
		2569
	],
	"./student/activities/minister/TakePhoto": [
		5246,
		7270,
		5246
	],
	"./student/activities/minister/TakePhoto.vue": [
		5246,
		7270,
		5246
	],
	"./student/activities/mixins/ActivityFunctions": [
		2385,
		2421
	],
	"./student/activities/mixins/ActivityFunctions.js": [
		2385,
		2421
	],
	"./student/activities/mixins/PhotoFunctions": [
		7270,
		7270
	],
	"./student/activities/mixins/PhotoFunctions.js": [
		7270,
		7270
	],
	"./student/activities/spandoek/TakePhoto": [
		2477,
		7270,
		2477
	],
	"./student/activities/spandoek/TakePhoto.vue": [
		2477,
		7270,
		2477
	],
	"./student/activities/tweedekamer/ActivityUitslag": [
		5241,
		5241
	],
	"./student/activities/tweedekamer/ActivityUitslag.vue": [
		5241,
		5241
	],
	"./student/activities/tweedekamer/PanoramaViewer": [
		5488,
		7848
	],
	"./student/activities/tweedekamer/PanoramaViewer.vue": [
		5488,
		7848
	],
	"./student/activities/tweedekamer/TekeningKeuze": [
		1936,
		1936
	],
	"./student/activities/tweedekamer/TekeningKeuze.vue": [
		1936,
		1936
	],
	"./student/activities/tweedekamer/TekeningMaken": [
		1887,
		1887
	],
	"./student/activities/tweedekamer/TekeningMaken.vue": [
		1887,
		1887
	],
	"./student/setup/SetupGroupName": [
		3043,
		3043
	],
	"./student/setup/SetupGroupName.vue": [
		3043,
		3043
	],
	"./student/setup/SetupPrivacy": [
		3813,
		3813
	],
	"./student/setup/SetupPrivacy.vue": [
		3813,
		3813
	],
	"./student/setup/SetupRoomName": [
		8653,
		8653
	],
	"./student/setup/SetupRoomName.vue": [
		8653,
		8653
	],
	"./student/setup/SetupSession": [
		5762,
		5762
	],
	"./student/setup/SetupSession.vue": [
		5762,
		5762
	],
	"./student/setup/TestLocationGps": [
		6330,
		6330
	],
	"./student/setup/TestLocationGps.vue": [
		6330,
		6330
	],
	"./ui/AppButton": [
		5320
	],
	"./ui/AppButton.vue": [
		5320
	],
	"./ui/ConfirmPopup": [
		7863
	],
	"./ui/ConfirmPopup.vue": [
		7863
	],
	"./ui/ErrorBanner": [
		7044
	],
	"./ui/ErrorBanner.vue": [
		7044
	],
	"./ui/InputPopup": [
		1795,
		1795
	],
	"./ui/InputPopup.vue": [
		1795,
		1795
	],
	"./ui/MessagePopup": [
		1321
	],
	"./ui/MessagePopup.vue": [
		1321
	],
	"./ui/ModalPopup": [
		4609,
		4609
	],
	"./ui/ModalPopup.vue": [
		4609,
		4609
	],
	"./ui/PasswordPopup": [
		8568
	],
	"./ui/PasswordPopup.vue": [
		8568
	],
	"./ui/QuitKeuzePopup": [
		9150
	],
	"./ui/QuitKeuzePopup.vue": [
		9150
	],
	"./ui/TimedConfirmPopup": [
		2648
	],
	"./ui/TimedConfirmPopup.vue": [
		2648
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7227;
module.exports = webpackAsyncContext;